import { render, staticRenderFns } from "./SectionItems.vue?vue&type=template&id=4495de63&scoped=true&"
import script from "./SectionItems.vue?vue&type=script&lang=js&"
export * from "./SectionItems.vue?vue&type=script&lang=js&"
import style0 from "./SectionItems.vue?vue&type=style&index=0&id=4495de63&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4495de63",
  null
  
)

export default component.exports